import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '@iconify/react';
import { IconButton, Tooltip, useMediaQuery, useTheme } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
export const BranchedIndicator = ({ parentOptionId, parentFieldLabel, parentOptionLabel }) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const isMobile = useMediaQuery(theme.breakpoints.down(1280));
    const handleClick = () => {
        if (isMobile) {
            setOpen((prev) => !prev);
            setTimeout(() => setOpen(false), 2000); // auto-close after 2s
        }
    };
    const hasParentLinkage = parentOptionId || parentFieldLabel || parentOptionLabel;
    if (!hasParentLinkage)
        return null;
    const tooltipTitle = (() => {
        const prefix = t('events.branchedFrom') || 'Branched from';
        const parts = [parentFieldLabel, parentOptionLabel].filter(Boolean);
        return parts.length > 0
            ? `${prefix} : ${parts.join(' : ')}`
            : t('events.branchedField') || 'This field is shown conditionally';
    })();
    return (_jsx(Tooltip, { title: tooltipTitle, arrow: true, placement: isMobile ? 'auto' : 'left', open: isMobile ? open : undefined, disableHoverListener: isMobile, disableFocusListener: isMobile, disableTouchListener: isMobile, children: _jsx("span", { style: { display: 'inline-flex' }, onClick: handleClick, children: _jsx(IconButton, { color: 'default', size: 'small', disabled: true, sx: {
                    border: 'none',
                    borderRadius: 1.5,
                    width: 28,
                    height: 28,
                    '&.Mui-disabled': {
                        border: 'none'
                    }
                }, children: _jsx(Icon, { icon: 'material-symbols:arrow-split-rounded', fontSize: '14px' }) }) }) }));
};
